import getters from './getters'
import mutations from './mutations'
import actions from './actions'

const state = {
  updatedData: {},
  updatedUnityData: {},
  programmerComments: [],
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
